/** Namespaced client logs so you can filter the console by `flowcore`. */

export function logWarn(scope, ...args) {
  console.warn(`[flowcore:${scope}]`, ...args);
}

export function logError(scope, ...args) {
  console.error(`[flowcore:${scope}]`, ...args);
}

export function logInfo(scope, ...args) {
  if (process.env.NODE_ENV === 'development') {
    console.info(`[flowcore:${scope}]`, ...args);
  }
}
